// extracted by mini-css-extract-plugin
export default {"page":"styles_page__s0D4A","header":"styles_header__c5m3d","backButton":"styles_backButton__rtwgQ","content":"styles_content__CV8mr"};